<script setup>
import { defineProps, defineEmits } from "vue"

defineProps({
  modelValue: {
    type: [String, Number],
    default: null
  },
  options: {
    type: Array,
    required: true // [{ value: "a", label: "Option A" }, ...]
  },
  name: {
    type: String,
    default: "radio-group"
  }
})

const emit = defineEmits(["update:modelValue"])

const updateValue = (value) => {
  emit("update:modelValue", value)
}
</script>

<template>
  <div class="btn-group" role="group">
    <template v-for="opt in options" :key="opt.value">
      <input
          type="radio"
          class="btn-check"
          :id="`${name}-${opt.value}`"
          :name="name"
          :value="opt.value"
          :checked="modelValue === opt.value"
          @change="updateValue(opt.value)"
      />
      <label class="btn btn-sm btn-outline-primary" :for="`${name}-${opt.value}`">
        {{ opt.label }}
      </label>
    </template>
  </div>
</template>
